import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { result as e } from "../../core/asyncUtils.js";
import { throwIfAborted as r } from "../../core/promiseUtils.js";
import o from "../../core/Warning.js";

function t(_x, _x2, _x3) {
  return _t.apply(this, arguments);
}

function _t() {
  _t = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(t, i, n) {
    var s, a, _e;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            s = t && t.getAtOrigin && t.getAtOrigin("renderer", i.origin);

            if (!(s && "unique-value" === s.type && s.styleOrigin)) {
              _context.next = 6;
              break;
            }

            _context.next = 4;
            return e(s.populateFromStyle());

          case 4:
            a = _context.sent;

            if (r(n), !1 === a.ok) {
              _e = a.error;
              i && i.messages && i.messages.push(new o("renderer:style-reference", "Failed to create unique value renderer from style reference: ".concat(_e.message), {
                error: _e,
                context: i
              })), t.clear("renderer", i.origin);
            }

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _t.apply(this, arguments);
}

export { t as loadStyleRenderer };